/**
   * @ngdoc directive
   * @name adjust.directive:datepickerWrapper
   * @scope
   *
   * @description
   * Directive that wraps pickadate lib and allows for general default options settings in our case
   * just week-starts-on param
   */
function datepickerWrapper() {
  'ngInject';
  return {
    restrict: 'E',
    scope: {
      inputName: '@',
      inputModel: '=',
      inputMin: '=',
      inputMax: '=',
      inputDisabledDates: '=?',
      inputRequired: '='
    },
    template: '<input type="text" name="{{ inputName }}" ng-model="inputModel" class="input" pickadate min-date="inputMin" max-date="inputMax" disabled-dates="inputDisabledDates" ng-required="inputRequired" week-starts-on="1" readonly>'
  };
}
export { datepickerWrapper };
